import { React, useState } from "react";
import Person3Icon from '@mui/icons-material/Person3';
import ForumIcon from '@mui/icons-material/Forum';
import BannerBreadcrumb from "../Components/BannerBreadcrumb";
const Overview = () => {
const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Overview"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Overview"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    return (
        <>
            <BannerBreadcrumb head={"A Complete Guide on How to Study Abroad"} parades={"All you need to know about education loans for studying abroad"} pagename={"Overview"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <p className="loan-elegibility-des mt-0">Starting your journey abroad begins with exploring. It’s about seeing what’s out there for education in other countries and what these opportunities mean for you. This step helps you understand what to expect and prepares you for the journey ahead.</p>
                            <h5 className="about-head">Things To Know Before You Embark!</h5>
                            <p className="loan-elegibility-des">Before you start, it’s key to know why studying abroad is a good idea. You’ll look into how it can help your studies, career, and personal growth. It’s time to think about your goals and how studying in another country can help you reach them.
                                Let’s now discuss them in detail</p>
                            <h5 className="about-head">Why Go For an Abroad Education?</h5>
                            <p className="loan-elegibility-des">Studying abroad is a significant step for Indian students, offering a blend of personal and professional growth. It’s a chance to experience new cultures, gain a global viewpoint, and enhance career opportunities. With a 35% increase in 2023, the number of Indian students pursuing education abroad reached a record 1.2 Million. This growth highlights the increasing desire among Indian students for quality education and international exposure, supported by more accessible scholarships and eased travel restrictions.</p>
                            <h6 className="subhead">Purpose</h6>
                            <p className="loan-elegibility-des">The primary goal of studying abroad is to enrich your academic and life experience. It’s about gaining independence, embracing new challenges, and building a diverse network of friends and professional contacts from around the world. Whether you’re seeking to advance your career, pursue research, or develop new skills, studying abroad can provide the platform you need to achieve your objectives.

                            </p>
                            <h6 className="subhead">Benefits</h6>
                            <p className="loan-elegibility-des">Studying abroad offers unparalleled benefits, enriching your academic journey and providing a competitive edge in your career. Here’s a condensed overview of the key advantages:</p>
                            <ol className="subhead-ul">
                                <li><b>Academic excellence :</b> Gain access to top-tier faculties and innovative research opportunities, enhancing your knowledge and skills in a global setting.</li>
                                <li><b>Global network :</b> Connect with peers and professionals worldwide, opening doors to international collaborations and opportunities.</li>

                                <li><b>Cultural immersion :</b> Experience diverse cultures firsthand, improving your language skills and cultural understanding.</li>
                                <li><b>Career advancement :</b> Boost your employability with international experience, sought after for adaptability and global insight.</li>
                            </ol>
                            <h6 className="subhead">Challenges</h6>
                            <p className="loan-elegibility-des">While studying abroad opens doors to countless opportunities, it also comes with its set of challenges that students need to navigate. Being prepared for these hurdles can make your journey smoother and more rewarding. Here’s a closer look at the challenges you might face:</p>
                            <ol className="subhead-ul">
                                <li><b>Financial investment :</b> The cost of tuition, accommodation, living expenses, and travel can add up, making financial planning essential.</li>
                                <li><b>Cultural adaptation :</b> Immersing yourself in a new culture means adjusting to different social norms and possibly overcoming language barriers.</li>

                                <li><b>Academic differences :</b> Universities abroad might have different teaching styles, study expectations, and workload compared to what you’re used to.</li>
                                <li><b>Emotional adjustment :</b> Moving away from home can lead to feelings of homesickness and the challenge of forming a new social circle in an unfamiliar environment.</li>
                            </ol>
                            <p className="loan-elegibility-des">Understanding the financial implications and potential returns on your investment in overseas education is crucial. Use our future earning estimator tool to get an insight into your potential earnings based on your chosen field of study, destination country, and university. This can help you make an informed decision about where and what to study abroad.</p>
                            <h5 className="about-head">Which Are The Top Countries To Study Abroad?</h5>
                            <p className="loan-elegibility-des">Choosing where to study abroad is a big decision that depends on what you want to study and the experiences you’re looking for. Countries like the USA, UK, Canada, Australia, Germany, France, New Zealand, and Ireland are top choices, each with world-class universities and a range of courses from engineering to humanities. This choice influences not just your academic growth but your personal development too, exposing you to new cultures and perspectives. Here’s a quick look at what each destination has to offer:</p>
                            <table className="table table-bordered table-striped customtable">
                                <thead className="table-head">
                                    <tr>
                                        <th>Country</th>
                                        <th>Renowned Universities</th>
                                        <th>Popular Courses</th>
                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>USA</td>
                                        <td>MIT, Stanford, Harvard</td>
                                        <td>Business, Technology, Engineering</td>
                                    </tr>
                                    <tr>
                                        <td>UK</td>
                                        <td>Oxford, Cambridge, Imperial College London</td>
                                        <td>Humanities, Law, Business</td>
                                    </tr>
                                    <tr>
                                        <td>Canada</td>
                                        <td>University of Toronto, McGill University</td>
                                        <td>Environmental Science, Engineering</td>
                                    </tr>
                                    <tr>
                                        <td>Australia</td>
                                        <td>University of Melbourne, Australian National University</td>
                                        <td>Medicine, Environmental Sciences</td>
                                    </tr>
                                    <tr>
                                        <td>Germany</td>
                                        <td>Technical University of Munich, University of Heidelberg</td>
                                        <td>Engineering, Physics, Informatics</td>
                                    </tr>
                                    <tr>
                                        <td>France</td>
                                        <td>Sorbonne University, Ecole Normale Supérieure</td>
                                        <td>Business, History, Fine Arts</td>
                                    </tr>
                                    <tr>
                                        <td>New Zealand</td>
                                        <td>University of Auckland, University of Otago</td>
                                        <td>Agriculture, Environmental Sciences</td>
                                    </tr>
                                    <tr>
                                        <td>Ireland</td>
                                        <td>Trinity College Dublin, University College Dublin</td>
                                        <td>Literature, Technology, Medicine</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="loan-elegibility-des">This table offers a starting point for your journey into international education, showcasing a world brimming with academic excellence and diverse experiences. Your choice will shape not only your career but also your global perspective.</p>
                            <h5 className="about-head">How Can Studying Abroad Help Your Career Growth?</h5>
                            <p className="loan-elegibility-des">Studying abroad can lead to excellent job prospects across various fields:</p>
                            <ol className="subhead-ul">
                                <li><b>Global opportunities :</b> Access to international job markets and roles in multinational companies.</li>
                                <li><b>Enhanced skills :</b> Development of cross-cultural communication, adaptability, and problem-solving skills.</li>

                                <li><b>Higher salaries :</b> Potential for higher earnings due to unique qualifications and experiences.</li>
                                <li><b>Networking :</b> Connections with professionals and alumni worldwide.</li>
                                <li><b>Innovative perspectives :</b> Employers value the fresh insights and diverse viewpoints brought by those with international education.</li>
                            </ol>
                            <p className="loan-elegibility-des">This global exposure not only broadens your career options but also makes you a valuable asset to employers looking for a global perspective.</p>
                            <h5 className="about-head">Things You Will Need for Your Application!</h5>
                            <p className="loan-elegibility-des">For your application to study abroad, you’ll need to gather important documents and meet certain requirements. Here are the following –</p>
                            <ol className="subhead-ul">
                                <li><b>SOP (Statement of purpose) :</b> This is your personal essay, where you share your dreams, goals, and the reasons you’re drawn to a particular program. It’s your chance to show off what drives you and how the program fits into your future plans.</li>
                                <li><b>LOR (Letters of recommendation) :</b> These are endorsements from people who know you well, like teachers or bosses. They share stories and examples of why you’re awesome and how you’ve shown your skills and character in real-life situations.</li>

                                <li><b>College grades :</b> Universities abroad often look at your grades to get an idea of how well you’ve done academically. They usually have a minimum GPA you need to have, but the exact number can vary by school and program.</li>
                                <li><b>Tests :</b> Depending on where and what you want to study, you might need to take some tests. These can be English language tests like the TOEFL or IELTS, exams for graduate school like the GRE or GMAT, the SAT for undergrad programs in the US, or even specific tests related to your field of study.</li>
                                <li><b>Work experience :</b> For some programs, especially at the graduate level, what you’ve done professionally can be just as important as your academic record. This is especially true for programs like MBAs, where real-world experience is valued.</li>
                                <li><b>Resume :</b> This document gives a snapshot of your educational and professional journey, highlighting your academic background, work history, skills, and any extracurricular activities or achievements.</li>

                                <li><b>Projects :</b> Including detailed descriptions of projects you’ve worked on, whether they’re research, volunteer, creative, or group projects, can showcase your practical skills and your ability to apply what you’ve learned.</li>
                                <li><b>Research papers/journals :</b> If you’ve been involved in research or published work, mentioning these can demonstrate your expertise and commitment to your field of study.</li>
                                <li><b>Achievements :</b> Lastly, don’t forget to include any awards, honors, or recognitions you’ve received. These can help you stand out from other applicants and show your potential for success.</li>
                            </ol>
                            <p className="loan-elegibility-des">Each of these pieces adds to the overall picture of who you are and what you bring to the table, making your application stronger and more compelling.</p>
                            <h5 className="about-head">Ways to Fund Your Study Abroad Journey!</h5>
                            <p className="loan-elegibility-des">Finding the right financial support for your study abroad journey is crucial. Here are some common ways to fund your education overseas:</p>
                            <ol className="subhead-ul">
                                <li><b>Scholarships/grants :</b> Scholarships and grants are great because you don’t have to pay them back. They can be based on your academic performance, extracurricular activities, or even personal background. Start looking early, as these opportunities can be competitive and have early deadlines.</li>
                                <li><b>Loans :</b> Student loans can help cover tuition and living expenses, but remember, they need to be repaid with interest. There are various types, including federal student loans and private loans, each with its own terms and conditions.</li>

                                <li><b>Self-funding :</b> This involves using your or your family’s savings to pay for your studies. It requires careful budgeting and planning to ensure you can manage all expenses, including tuition, accommodation, and day-to-day living costs.</li>
                            </ol>
                            <p className="loan-elegibility-des">Exploring each of these options thoroughly can help you make informed decisions about funding your education abroad.</p>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Overview;